// Polyfills for AWS Amplify compatibility with Vite
window.global = window;
window.process = window.process || {};
window.process.env = window.process.env || {};
window.process.browser = true;
window.process.version = '';
window.process.versions = { node: false };